import React from "react";
import { View, NotFoundBoundary, useLoadingRoute } from "react-navi";
import NotFoundPage from "./NotFoundPage";
import LoadingIndicator from "./LoadingIndicator";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import styles from "./BlogLayout.module.css";

function BlogLayout({ blogRoot }) {
  let loadingRoute = useLoadingRoute();

  return (
    <div className={styles.root}>
      <LoadingIndicator active={!!loadingRoute} />
      <BlogHeader blogRoot={blogRoot} />

      <main className={styles.main}>
        <NotFoundBoundary render={() => <NotFoundPage />}>
          <View />
        </NotFoundBoundary>
      </main>

      <BlogFooter />
    </div>
  );
}

export default BlogLayout;
